module.exports = __webpack_public_path__ + "static/media/home-banner-mobile.abebe27d.png";